import React from 'react';
import PropTypes from 'prop-types';

/**
 * Tag
 *  - Main Title of group
 */
export function Tag(props) {
  const style = {color: props.color};
  return (
    <p className={props.className} style={style}>
      {props.text}
    </p>
  );
}

Tag.propTypes = {
  /**
   * ClassName
   */
  className: PropTypes.string,
  /**
   * Text to display on Tag
   */
  text: PropTypes.string,
  /**
   * Theme color of group
   */
  color: PropTypes.string,
};

Tag.defaultProps = {
  className: '',
  text: '',
};
